import { render, staticRenderFns } from "./DefaultUserCard.vue?vue&type=template&id=7a2c4a3e&scoped=true&"
import script from "./DefaultUserCard.vue?vue&type=script&lang=ts&"
export * from "./DefaultUserCard.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultUserCard.vue?vue&type=style&index=0&id=7a2c4a3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2c4a3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})
